import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import { getSynchronizedTeamsByShop, updateShopOnFleetSettings } from '../../actions/integration'

import {
  Grid,
  Button,
  ExpansionPanelDetails,
  Typography,
  ListItem,
  MenuItem,
  Tooltip,
  withStyles,
} from '@material-ui/core'
import { EditableSelect, EditableSwitch } from '../common/EditableComponents'
import { updateShop } from '../../actions/shop'
import InfoIcon from '@material-ui/icons/Info'
import { openErrorMessage } from '../../actions/message'

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip)

class OnFleetSettingInfoShopSettings extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      onFleetTeamInfo: {},
      enableUnAssignedOnfleetOrder:
        (props.shop && props.shop.enableUnAssignedOnfleetOrder) || false,
      autoOnFleetTeam: (props.shop && props.shop.autoOnFleetTeam) || '',
      onFleetRequired: (props.shop && props.shop.onFleetRequired) || false,
      enableColorPin: (props.shop && props.shop.enableColorPin) || false,
      colorSameDay: (props.shop && props.shop.colorSameDay) || '',
      colorNextDay: (props.shop && props.shop.colorNextDay) || '',
      colorBeyondNextDay: (props.shop && props.shop.colorBeyondNextDay) || '',
      onFleetAllowEmptyOrders: (props.shop && props.shop.onFleetAllowEmptyOrders) || false,
      onFleetTwoWay: (props.shop && props.shop.onFleetTwoWay) || false,
      onFleetTwoWayUpdateSchedule: (props.shop && props.shop.onFleetTwoWayUpdateSchedule) || false,
      onFleetTwoWayRevert: (props.shop && props.shop.onFleetTwoWayRevert) || false,
      onFleetTwoAutoPack: (props.shop && props.shop.onFleetTwoAutoPack) || false,
    }
  }

  componentDidMount() {
    const { shop = {} } = this.props
    this.props.dispatch(getSynchronizedTeamsByShop({ shopId: shop.id })).then((res) => {
      this.setState({
        onFleetTeamInfo: res || {},
      })
    })
  }

  onChange = (key, value, isSelect) => (e) => {
    if (isSelect) {
      this.setState({ [key]: e.target.value })
    } else {
      this.setState({ [key]: !value })
    }
  }

  toggleEdit = () => {
    this.setState({
      enableUnAssignedOnfleetOrder:
        (this.props.shop && this.props.shop.enableUnAssignedOnfleetOrder) || false,
      autoOnFleetTeam: (this.props.shop && this.props.shop.autoOnFleetTeam) || '',
      onFleetRequired: (this.props.shop && this.props.shop.onFleetRequired) || false,
      editMode: !this.state.editMode,
      enableColorPin: (this.props.shop && this.props.shop.enableColorPin) || false,
      colorSameDay: (this.props.shop && this.props.shop.colorSameDay) || '',
      colorNextDay: (this.props.shop && this.props.shop.colorNextDay) || '',
      colorBeyondNextDay: (this.props.shop && this.props.shop.colorBeyondNextDay) || '',
      onFleetAllowEmptyOrders:
        (this.props.shop && this.props.shop.onFleetAllowEmptyOrders) || false,
      onFleetTwoWay: (this.props.shop && this.props.shop.onFleetTwoWay) || false,
      onFleetTwoWayUpdateSchedule:
        (this.props.shop && this.props.shop.onFleetTwoWayUpdateSchedule) || false,
      onFleetTwoWayRevert: (this.props.shop && this.props.shop.onFleetTwoWayRevert) || false,
      onFleetTwoAutoPack: (this.props.shop && this.props.shop.onFleetTwoAutoPack) || false,
    })
  }

  onUpdate = () => {
    const { shop = {}, autoOnFleetIncomingOrders } = this.props
    const {
      enableUnAssignedOnfleetOrder,
      autoOnFleetTeam,
      onFleetRequired,
      enableColorPin,
      colorSameDay,
      colorNextDay,
      colorBeyondNextDay,
      onFleetAllowEmptyOrders,
      onFleetTwoWay,
      onFleetTwoWayUpdateSchedule,
      onFleetTwoWayRevert,
      onFleetTwoAutoPack,
    } = this.state

    if (autoOnFleetIncomingOrders && !autoOnFleetTeam) {
      this.props.dispatch(openErrorMessage('Please select an Onfleet Team'))
      return null
    }

    shop.enableUnAssignedOnfleetOrder = enableUnAssignedOnfleetOrder
    shop.autoOnFleetTeam = autoOnFleetTeam
    shop.onFleetRequired = onFleetRequired
    shop.enableColorPin = enableColorPin
    shop.colorSameDay = colorSameDay
    shop.colorNextDay = colorNextDay
    shop.colorBeyondNextDay = colorBeyondNextDay
    shop.onFleetAllowEmptyOrders = onFleetAllowEmptyOrders
    shop.onFleetTwoWay = onFleetTwoWay
    shop.onFleetTwoWayUpdateSchedule = onFleetTwoWayUpdateSchedule
    shop.onFleetTwoWayRevert = onFleetTwoWayRevert
    shop.onFleetTwoAutoPack = onFleetTwoAutoPack
    shop.shopId = shop.id

    let onFleetSettings = {
      enableUnAssignedOnfleetOrder: enableUnAssignedOnfleetOrder,
      autoOnFleetTeam: autoOnFleetTeam,
      onFleetRequired: onFleetRequired,
      enableColorPin: enableColorPin,
      colorSameDay: colorSameDay,
      colorNextDay: colorNextDay,
      colorBeyondNextDay: colorBeyondNextDay,
      onFleetAllowEmptyOrders: onFleetAllowEmptyOrders,
      onFleetTwoWay: onFleetTwoWay,
      onFleetTwoWayUpdateSchedule: onFleetTwoWayUpdateSchedule,
      onFleetTwoWayRevert: onFleetTwoWayRevert,
      onFleetTwoAutoPack: onFleetTwoAutoPack,
      shopId: shop.id,
    }

    this.props.dispatch(updateShopOnFleetSettings(onFleetSettings)).then((res) => {
      this.toggleEdit()
    })
  }

  render() {
    const { shop = {}, autoOnFleetIncomingOrders, onfleetTwoWaysEnabled = false } = this.props
    const { onFleetTeamInfo = {} } = this.state
    const {
      enableUnAssignedOnfleetOrder = false,
      autoOnFleetTeam,
      onFleetRequired = false,
      enableColorPin = false,
      editMode = false,
      colorSameDay,
      colorNextDay,
      colorBeyondNextDay,
      onFleetAllowEmptyOrders = false,
      onFleetTwoWay = false,
      onFleetTwoWayUpdateSchedule = false,
      onFleetTwoWayRevert = false,
      onFleetTwoAutoPack = false,
    } = this.state
    const onFleetTeamInfoList = onFleetTeamInfo.onFleetTeamInfoList || []
    const onFleetTeam = onFleetTeamInfoList.find((team) => team.id == shop.autoOnFleetTeam)

    return (
      <ExpansionPanelDetails>
        <div className="full-width">
          {!editMode ? (
            <Button className="primary-button pull-right" onClick={this.toggleEdit}>
              {' '}
              Edit{' '}
            </Button>
          ) : (
            <div className="pull-right margin-bottom-small">
              <Button className="primary-button margin" onClick={this.onUpdate}>
                Save
              </Button>
              <Button className="danger-button margin" onClick={this.toggleEdit}>
                Cancel
              </Button>
            </div>
          )}
          <Grid container className="listing-spacing">
            {autoOnFleetIncomingOrders && (
              <ListItem>
                <Grid container>
                  <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>Auto Send to Onfleet | Onfleet Team</Typography>
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>
                      <EditableSelect
                        value={autoOnFleetTeam}
                        onChange={this.onChange('autoOnFleetTeam', autoOnFleetTeam, true)}
                        valueToRender={(onFleetTeam && onFleetTeam.name) || ''}
                        editMode={editMode}
                      >
                        {onFleetTeamInfoList.map((onFleetTeam) => {
                          return <MenuItem value={onFleetTeam.id}>{onFleetTeam.name}</MenuItem>
                        })}
                      </EditableSelect>
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            )}
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Allow Unassigned Orders</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={onFleetRequired ? false : enableUnAssignedOnfleetOrder}
                      onChange={this.onChange(
                        'enableUnAssignedOnfleetOrder',
                        enableUnAssignedOnfleetOrder,
                      )}
                      valueToRender={enableUnAssignedOnfleetOrder ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                      disabled={onFleetRequired}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Require Onfleet Team</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableUnAssignedOnfleetOrder ? false : onFleetRequired}
                      onChange={this.onChange('onFleetRequired', onFleetRequired)}
                      valueToRender={onFleetRequired ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                      disabled={enableUnAssignedOnfleetOrder}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Allow Empty Orders</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                  <Typography>
                    <EditableSwitch
                      valueToRender={onFleetAllowEmptyOrders ? 'Enabled' : 'Disabled'}
                      checked={onFleetAllowEmptyOrders}
                      editMode={editMode}
                      onChange={this.onChange('onFleetAllowEmptyOrders', onFleetAllowEmptyOrders)}
                    />
                  </Typography>
                </Grid>
                <Grid>
                  <HtmlTooltip
                    placement="top-start"
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          If enabled, allow empty orders to be sent to Onfleet
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoIcon style={{ color: '#03a9f4' }} />
                  </HtmlTooltip>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Scheduled Colored Pins</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableColorPin}
                      onChange={this.onChange('enableColorPin', enableColorPin)}
                      valueToRender={enableColorPin ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            {enableColorPin && (
              <ListItem>
                <Grid container>
                  <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>Same Day Delivery</Typography>
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>
                      <EditableSelect
                        value={colorSameDay}
                        onChange={this.onChange('colorSameDay', colorSameDay, true)}
                        valueToRender={colorSameDay[0] + colorSameDay.slice(1).toLowerCase()}
                        editMode={editMode}
                      >
                        <MenuItem value="NONE">None</MenuItem>
                        <MenuItem value="TEAL">Teal</MenuItem>
                        <MenuItem value="ORANGE">Orange</MenuItem>
                        <MenuItem value="MAGENTA">Magenta</MenuItem>
                      </EditableSelect>
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            )}
            {enableColorPin && (
              <ListItem>
                <Grid container>
                  <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>Next Day Delivery</Typography>
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>
                      <EditableSelect
                        value={colorNextDay}
                        onChange={this.onChange('colorNextDay', colorNextDay, true)}
                        valueToRender={colorNextDay[0] + colorNextDay.slice(1).toLowerCase()}
                        editMode={editMode}
                      >
                        <MenuItem value="NONE">None</MenuItem>
                        <MenuItem value="TEAL">Teal</MenuItem>
                        <MenuItem value="ORANGE">Orange</MenuItem>
                        <MenuItem value="MAGENTA">Magenta</MenuItem>
                      </EditableSelect>
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            )}
            {enableColorPin && (
              <ListItem>
                <Grid container>
                  <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>Beyond Next Day Delivery</Typography>
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>
                      <EditableSelect
                        value={colorBeyondNextDay}
                        onChange={this.onChange('colorBeyondNextDay', colorBeyondNextDay, true)}
                        valueToRender={
                          colorBeyondNextDay[0] + colorBeyondNextDay.slice(1).toLowerCase()
                        }
                        editMode={editMode}
                      >
                        <MenuItem value="NONE">None</MenuItem>
                        <MenuItem value="TEAL">Teal</MenuItem>
                        <MenuItem value="ORANGE">Orange</MenuItem>
                        <MenuItem value="MAGENTA">Magenta</MenuItem>
                      </EditableSelect>
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            )}
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>2-Way | Assign Orders</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                  <Typography>
                    <EditableSwitch
                      valueToRender={
                        onfleetTwoWaysEnabled == false
                          ? 'Unavailable'
                          : onFleetTwoWay
                          ? 'Enabled'
                          : 'Disabled'
                      }
                      checked={onFleetTwoWay}
                      editMode={onfleetTwoWaysEnabled && editMode}
                      onChange={this.onChange('onFleetTwoWay', onFleetTwoWay)}
                    />
                  </Typography>
                </Grid>
                <Grid>
                  <HtmlTooltip
                    placement="top-start"
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          If enabled, allow Onfleet to communicate with BLAZE. Please reach out to
                          BLAZE Support if option is "Unavailable"
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoIcon style={{ color: '#03a9f4' }} />
                  </HtmlTooltip>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>2-Way | Unassign Orders</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                  <Typography>
                    <EditableSwitch
                      valueToRender={
                        onfleetTwoWaysEnabled == false
                          ? 'Unavailable'
                          : onFleetTwoWayRevert && onfleetTwoWaysEnabled
                          ? 'Enabled'
                          : 'Disabled'
                      }
                      checked={onFleetTwoWayRevert}
                      disabled={!onFleetTwoWay}
                      editMode={onfleetTwoWaysEnabled && editMode}
                      onChange={this.onChange('onFleetTwoWayRevert', onFleetTwoWayRevert)}
                    />
                  </Typography>
                </Grid>
                <Grid>
                  <HtmlTooltip
                    placement="top-start"
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          If enabled, send to "Unassigned," if assignment from Onfleet fails. Please
                          reach out to BLAZE Support if option is "Unavailable"
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoIcon style={{ color: '#03a9f4' }} />
                  </HtmlTooltip>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>2-Way | Auto-pack Orders</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                  <Typography>
                    <EditableSwitch
                      valueToRender={
                        onfleetTwoWaysEnabled == false
                          ? 'Unavailable'
                          : onFleetTwoAutoPack && onfleetTwoWaysEnabled
                          ? 'Enabled'
                          : 'Disabled'
                      }
                      checked={onFleetTwoAutoPack}
                      disabled={!onFleetTwoWay}
                      editMode={onfleetTwoWaysEnabled && editMode}
                      onChange={this.onChange('onFleetTwoAutoPack', onFleetTwoAutoPack)}
                    />
                  </Typography>
                </Grid>
                <Grid>
                  <HtmlTooltip
                    placement="top-start"
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          If enabled, auto set the packed information if order is unpacked. The
                          assigned driver would be the packer. Please reach out to BLAZE Support if
                          option is "Unavailable"
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoIcon style={{ color: '#03a9f4' }} />
                  </HtmlTooltip>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>2-Way | Update Schedule</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                  <Typography>
                    <EditableSwitch
                      valueToRender={
                        onfleetTwoWaysEnabled == false
                          ? 'Unavailable'
                          : onFleetTwoWayUpdateSchedule && onfleetTwoWaysEnabled
                          ? 'Enabled'
                          : 'Disabled'
                      }
                      checked={onFleetTwoWayUpdateSchedule}
                      disabled={!onFleetTwoWay}
                      editMode={onfleetTwoWaysEnabled && editMode}
                      onChange={this.onChange(
                        'onFleetTwoWayUpdateSchedule',
                        onFleetTwoWayUpdateSchedule,
                      )}
                    />
                  </Typography>
                </Grid>
                <Grid>
                  <HtmlTooltip
                    placement="top-start"
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          If enabled, allow Onfleet to update scheduled time. Please reach out to
                          BLAZE Support if option is "Unavailable"
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoIcon style={{ color: '#03a9f4' }} />
                  </HtmlTooltip>
                </Grid>
              </Grid>
            </ListItem>
          </Grid>
        </div>
      </ExpansionPanelDetails>
    )
  }
}

export default connect(({ dispatch }) => ({ dispatch }))(OnFleetSettingInfoShopSettings)



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetSettingInfoShopSettings.js